import React from 'react';
import { CompassIcon, EyeIcon, FlaskConicalIcon, RocketIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = [CompassIcon, FlaskConicalIcon, EyeIcon, RocketIcon];
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-noche" data-id="element-16" data-mp="3npb39e632mfj">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3nnglg8q3zafo">
        <h2 id="beneficios" className="font-display text-[1.75rem] uppercase leading-[1.08] tracking-wide text-white sm:text-5xl" data-id="element-18" data-mp="38qzcfo5e67wa">
          ¿Qué puede cambiar cuando{' '}
          <span className="text-oro" data-id="element-19" data-mp="2zsnltm4iza3u">empiezas?</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-20" data-mp="34q5jggd3e2wj">
          Comprender química puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="y0qxtd1687s6">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[i];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-ciencia bg-white p-2.5 text-left" data-id="element-22" data-mp="2bedzpgakboc0" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-verde text-white" aria-hidden="true" data-id="element-23" data-mp="2l47bahapg3g9">
                  <Icon size={16} data-id="element-24" data-mp="1sgla1foy9awk" />
                </span>
                <div data-id="element-25" data-mp="1of86jc9bxjst">
                  <h3 className="font-sub text-sm font-extrabold leading-tight text-noche" data-id="element-26" data-mp="1og1cib0gs59w">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-noche/80 sm:text-sm" data-id="element-27" data-mp="1xfeekim9drkl">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}